import React from 'react';
import { Card, CardContent, Box } from '@mui/material';
import ShimmerBox from './ShimmerBox';

const ProjectCardShimmer: React.FC = () => (
  <Card
    data-testid="project-card-shimmer"
    sx={{
      borderRadius: 3,
      border: '1px solid var(--border-light)',
      bgcolor: 'var(--bg-primary)',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
      overflow: 'visible',
    }}
  >
    <CardContent sx={{ p: 1.75 }}>
      <Box sx={{ mb: 1.5 }}>
        <ShimmerBox className="mb-2 h-4 w-3/4 max-w-[180px] rounded-md" />
        <ShimmerBox className="h-3 w-full rounded" />
        <ShimmerBox className="mt-1.5 h-3 w-4/5 rounded" />
      </Box>

      <Box sx={{ display: 'flex', gap: 1.5, mb: 1.5 }}>
        {[0, 1].map((item) => (
          <Box
            key={item}
            sx={{
              flex: 1,
              p: 1,
              borderRadius: 1.5,
              border: '1px solid rgba(102, 122, 255, 0.1)',
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
            }}
          >
            <ShimmerBox className="h-7 w-7 shrink-0 rounded-[10px]" />
            <Box sx={{ flex: 1 }}>
              <ShimmerBox className="mb-1 h-2.5 w-10 rounded" />
              <ShimmerBox className="h-4 w-6 rounded" />
            </Box>
          </Box>
        ))}
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <ShimmerBox className="h-3 w-24 rounded" />
        <ShimmerBox className="h-6 w-16 rounded-full" />
      </Box>
    </CardContent>
  </Card>
);

export default ProjectCardShimmer;
